<template lang="pug">
  svgicon(
    :data="renderContent"
    :fill="fill"
    v-if="renderContent"
    :original="original"
    :class="{ [$options.name]: true, 'default-size': defaultSize, 'small-size': small }"
    :aria-label="ariaLabel"
  )

</template>

<script>
  import { getIconModules } from "@utilities/path";

  const iconModules = getIconModules();

  export default {
    name: "mr-icon",

    props: {
      name: {
        type: String,
        required: false,
        default: null
      },
      // and for that reason the color should be set via css
      fill: {
        type: Boolean,
        default: true
      },
      original: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      content: {
        type: Object,
        default: null
      },
      alt: {
        type: String,
        default: null
      }
    },

    data() {
      return {
        svgContent: null,
      };
    },

    computed: {
      defaultSize() {
        return !(this.$attrs.height);
      },

      ariaLabel() {
        return this.alt || `${this.name} icon`;
      },

      renderContent() {
        return this.content || this.svgContent;
      }
    },

    watch: {
      name: {
        handler: 'loadIcon',
      },
    },

    mounted() {
      this.loadIcon();
    },

    methods: {
      loadIcon() {
        if (!this.name) {
          return;
        }
        // The `[request]` placeholder is replaced
        // by the filename of the file which is
        // loaded (e.g. `mr-icon-zoom-in.js`).
        const module = iconModules[this.name];
        if (!module) {
          console.error(`Icon ${this.name} not found`);
          return;
        }
        module().then((svgModule) => {
          this.svgContent = svgModule.default;
        });
      },
    }

  };
</script>

<style lang="stylus">

  .mr-icon
    display inline-block
    color inherit
    vertical-align middle
    fill none
    stroke currentColor

    &.default-size
      width 1em

    &.small-size
      width 0.5em

  .mr-fill
    fill currentColor
    stroke none

  .fill-white
    fill color-white
</style>